import moment from "moment";

export function stringToMomentDate(dateString, format) {
  return moment(dateString, format);
}
export function momentDateToString(momentDate, format) {
  return momentDate.format;
}
export function stringToDate(dateString, format) {
  return moment(dateString, format).toDate();
}
export function dateToString(date, format) {
  return moment(date).format(format);
}

export function addDays(date, days) {
  const date2 = moment(date).add(days, 'days').toDate();
  return date2;
}